import styled from 'styled-components';
import theme from '../../../common/theme';

const ResourcesListStyles = styled.div`
  .header {
    margin: 0px -50px 0px;
    padding: 0px 50px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0px 14px 40px 0 rgba(0, 0, 0, 0.05);
  }
  .posting-wrapper {
    margin: 5px -50px -50px;
    padding: 15px 50px;
    background-color: #f7f7f7;
    min-height: 100vh;
  }

  .user-instructions {
    max-width: 1150px;
    width: 100%;
    margin: 0 auto;
  }

  .user-instructions h2 {
    display: flex;
    align-items: center;
    margin-top: 20px;
    font-size: 18px;
    color: ${theme.color.grayDark};
  }

  .user-instructions svg {
    margin-right: 5px;
  }

  .filter-button-item {
    padding: 9px 14px;
    border: 1px solid lightgray;
    border-radius: 9px;
    margin: 0 5px 5px 0;
    text-align: center;
    font-size: 0.8em;
    text-transform: capitalize;
    color: #4c4c4c;
    &.active {
      background: ${theme.color.blue};
      color: white;
    }
  }

  @media only screen and (max-width: 768px) {
    .header {
      margin: 0px -25px 0px;
      padding: 0px 25px 0px;
    }
    .posting-wrapper {
      margin: 5px -25px -25px;
      padding: 15px 25px;
    }
  }

  .MuiFilledInput-root {
    width: calc(100vw - 30px);
    margin-bottom: 5px;
  }
  .MuiFilledInput-root,
  .MuiSelect-select:focus {
    border-radius: 5px;
  }
  /* .MuiFilledInput-root,
  .MuiSelect-select:focus {
    background: #BCDCD2;
    border-radius: 5px;
  }
  .MuiFormControl-root {
    margin: 5px 5px 0 0;
  }
  .MuiFilledInput-input {
    border: none;
  }
  .MuiFilledInput-underline:before,
  .MuiFilledInput-underline:after {
    border: none;
  } */
`;

export const ResultsPageNavigator = styled.div`
  display: flex;
  align-content: flex-start;
  margin: 12px 0px 16px;
  .prev-next-container {
    display: flex;
    align-items: center;
    margin-left: auto;
    & > span {
      margin: 0px 12px;
    }
  }
`;

export default ResourcesListStyles;
